import type { ReactNode } from 'react';

/**
 * Full-screen modal: grays out and blurs the whole screen, centering a card.
 * Matches the booking closing-time warning. Pass `onClose` to allow dismissing
 * by tapping the backdrop; omit it for must-acknowledge dialogs.
 */
export function Modal({
  children, onClose, size = 'md',
}: {
  children: ReactNode;
  onClose?: () => void;
  size?: 'md' | 'lg';
}) {
  return (
    <div
      className="fixed inset-0 z-[95] flex items-center justify-center bg-espresso-deep/85 p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className={`w-full ${size === 'lg' ? 'max-w-lg' : 'max-w-md'} border border-line bg-cream p-7 shadow-soft sm:p-8`}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
